import { API_BASE_URL, BRAND, sleep } from './api';

const esc = (v) =>
  String(v ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

const yearOf = (r) => {
  const y = String(r?.year ?? '').trim();
  if (/^\d{4}$/.test(y)) return y;
  const d = String(r?.date ?? '');
  const m = d.match(/(\d{4})/);
  return m ? m[1] : '—';
};

export function buildReport(records, ctx) {
  const loc = (v) => esc(String(v || '—').trim() || '—');
  const rows = (r) => [
    ['Document', r.document_number],
    ['Type', r.document_type],
    ['Date', r.date],
    ['Seller', r.seller_party],
    ['Buyer', r.buyer_party],
    ['Description', r.text],
  ].map(([k, v]) => `<tr><th>${k}</th><td>${esc(v)}</td></tr>`).join('');

  const body = (records || []).map((r) => `<table>${rows(r)}</table><br/>`).join('');
  return `<!DOCTYPE html><html><head><meta charset="utf-8"/><title>${BRAND} Report</title>
<style>body{font-family:system-ui,sans-serif;max-width:800px;margin:24px auto;padding:0 16px;color:#1e293b}
table{width:100%;border-collapse:collapse;margin-bottom:16px;font-size:14px}th,td{border:1px solid #e2e8f0;padding:8px;text-align:left}
th{width:30%;background:#f8fafc;font-weight:600}h1{color:#0ea5e9;font-size:22px}</style></head>
<body><h1>${BRAND} — Property Report</h1>
<p>District: ${loc(ctx.district || ctx.de)} · Taluka: ${loc(ctx.taluka || ctx.te)} · Village: ${loc(ctx.village || ctx.ve)} · Property: ${loc(ctx.query)}</p>
${body}<p style="font-size:12px;color:#64748b">Generated ${new Date().toLocaleString('en-IN')}. Informational only.</p></body></html>`;
}

export function downloadHtml(html, name) {
  const blob = new Blob([html], { type: 'text/html;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  try { window.open(url, '_blank'); } catch (_) {}
  const a = document.createElement('a');
  a.href = url;
  a.download = name || 'Zameenmahiti_Report.html';
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 30000);
}

export function fullPayload(token, ctx, records) {
  const keys = records.map((r) => r?.key).filter(Boolean);
  if (!token || !keys.length) return null;
  return ctx.d
    ? { token, d: ctx.d, t: ctx.t, v: ctx.v, query: ctx.query, keys }
    : { token, district: ctx.district, taluka: ctx.taluka, village: ctx.village, query: ctx.query, keys };
}

export async function fetchPaid(body, retries = 8) {
  let res;
  for (let i = 0; i < retries; i++) {
    res = await fetch(`${API_BASE_URL}/search/full-by-keys`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    if (res.ok) return res;
    let msg = '';
    try { msg = (await res.json()).error || ''; } catch (_) {}
    if (res.status === 403 && /not marked as paid/i.test(msg) && i < retries - 1) {
      await sleep(Math.min(200 * 1.65 ** i, 3500));
      continue;
    }
    break;
  }
  return res;
}
